  
<style>
  

  .main-heading
  {
    margin-left: 10px;
    margin-bottom: 20px;
  }

  .sp-form-field
  {
    margin-bottom: 30px;
  }
  .sp-form-field-label {
    margin-bottom: 15px;
    font-weight: 600;
  }
  
  .right {
    float: right;
  }
  .description
  {
    margin-bottom: 20px;
  }
  .warning
  {
    color: red;
  }

  .missing-requirement {
    color: #000;
    width: 100%;
    font-size: 13px;
    text-align: right;
  }

  .dialog-action-block {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 8px;
  }

  .dialog-action-buttons {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }

  .dialog-shell {
    /*padding: 0 16px 16px 16px;*/
  }
</style>


<!--<h1 mat-dialog-title *ngIf="!isNewCustomer" style="margin-top: 5px;margin-bottom: 35px;">Redigera kund</h1>-->

<div class="dialog-shell expense-dialog">
  <form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm" novalidate>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="dialog-header">
          <div>
            <h2>Utlägg</h2>
            <p>Lägg till eller redigera utlägg och underlag.</p>
          </div>
          <button type="button" mat-icon-button aria-label="Stäng" (click)="cancel()"><mat-icon>close</mat-icon></button>
        </div>

        <!--<mat-form-field style="width:200px;margin-left: 10px; margin-right: 10px;" floatLabel="always">
    <mat-label>Beskrivning</mat-label>
    <input class="text-input" matInput [(ngModel)]="c.Description" [disabled]="!canUpdatePayout()">
  </mat-form-field>-->

      <div class="col-12 billing-choice" *ngIf="!deduction?.GroupId || data?.showInvoiceBillingChoice">
          <mat-checkbox [(ngModel)]="deduction.AddedToInvoice"
                        (ngModelChange)="onAddedToInvoiceChange($event)"
                        name="addedToInvoice"
                        [disabled]="data?.status?.TechnicalName !== 'Draft' || !isInvoiceCurrencySek">
            Ska faktureras till kund
          </mat-checkbox>
        </div>        

        <mat-form-field class="col-sm-12" *ngIf="deduction.AddedToInvoice" floatLabel="always">
          <mat-label>Utlägget avser (visas på fakturan till kund)</mat-label>
          <input type="text" matInput [ngModel]="deduction.Name" (ngModelChange)="deduction.Name = $event" required md-maxlength="50" id="name" name="name" />
        </mat-form-field>

        
        <!--<mat-form-field class="col-sm-6" floatLabel="always">
          <mat-label>Momssats</mat-label>
          <mat-select [(ngModel)]="deduction.VatPercentage" name="VatPercentage" matInput>
            <mat-option *ngFor="let item of vatList" value="{{item.Value}}">{{item.Value}} %</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="col-sm-12 sp-form-field">
          <span>Vid ett kvitto med olika momssatser: lägg till ett utlägg per momssats med respektive belopp och momssatser men använd samma kvitto</span>
        </div>-->

        <mat-form-field class="col-sm-12 description" floatLabel="always">
          <mat-label>Beskrivning/syfte</mat-label>
          <textarea matInput [ngModel]="deduction.Description" (ngModelChange)="deduction.Description = $event" required md-maxlength="500" rows="5" id="message" name="message" md-select-on-focus></textarea>
        </mat-form-field>

        <mat-form-field class="col-sm-12" floatLabel="always">
          <mat-label>Belopp (SEK)</mat-label>
          <input type="number" step="0.01" matInput [ngModel]="deduction.Amount" (ngModelChange)="deduction.Amount = $event" required md-maxlength="50" id="amount" name="amount" />
        </mat-form-field>


        <section class="choice-section">
          <div class="col-lg-12">
            <h4><b>Reseutlägg</b></h4>
            <p>Gäller ditt kvitto ett utlägg du gjort för resa i samband med det du fakturerat, t ex tågbiljetter, hotell, taxi eller liknande?</p>
          </div>
          <div class="col-lg-6">
            <mat-checkbox matInput [ngModel]="TravelExpense" [checked]="TravelExpense" (change)="changeValue($event, 'travel')" name="TravelExpense">Ja</mat-checkbox>
          </div>
        </section>

        <section class="choice-section">
          <div class="col-lg-12">
            <h4><b>Friskvårdsavdrag</b></h4>
            <p>Gäller ditt kvitto ett utlägg du gjort för för en friskvårdsaktivitet?</p>
            <p *ngIf="HealthCare"> Du får göra avdrag med max 5000 kr per kalenderår. Du har tidigare i år fått utbetalt friskvårdsavdrag med {{HealthCareAmountThisYear}} SEK, och du har <strong>{{5000 - HealthCareAmountThisYear}} SEK kvar att utnyttja.</strong></p>

          </div>
          <div class="col-lg-6">
            <mat-checkbox matInput [ngModel]="HealthCare" [checked]="HealthCare" (change)="changeValue($event, 'health')" name="HealthCare">Ja</mat-checkbox>
          </div>
        </section>

        <div class="col-sm-12 sp-form-field upload-section">
          <div class="sp-form-field-label">Ladda upp PDF-dokument eller bild *</div>
          <div *ngIf="deduction.Attachment.Guid == null" class="file-picker">
            <label class="file-picker-button" for="deduction-attachment">Välj fil</label>
            <span>{{deduction.Attachment.Name || 'Ingen fil har valts'}}</span>
            <input id="deduction-attachment" type="file" (change)="fileChange($event,deduction.Attachment)" accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif">
          </div>
          <div class="warning" *ngIf="fileSizeErrorAttachment">{{fileSizeErrorAttachment}}</div>
          <a *ngIf="deduction.Attachment.Guid != null" class="col-sm-8" mat-stroked-button color="secondary" (click)="showFile(deduction.Attachment)"><mat-icon>open_in_new</mat-icon>&nbsp; Visa dokument</a>&nbsp;
          <a *ngIf="deduction.Attachment.Guid != null" class="warning right col-sm-3" mat-stroked-button color="secondary" (click)="deleteFile(deduction.Attachment)">Radera</a>&nbsp;
        </div>

        <div class="col-sm-12 sp-form-field">
          <div class="sp-form-field-label">Är ovan fil en faktura, ladda upp kvittens på att fakturan är betald</div>
          <div *ngIf="deduction.AttachmentReciept.Guid == null" class="file-picker">
            <label class="file-picker-button" for="deduction-receipt">Välj fil</label>
            <span>{{deduction.AttachmentReciept.Name || 'Ingen fil har valts'}}</span>
            <input id="deduction-receipt" type="file" (change)="fileChange($event,deduction.AttachmentReciept)" accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.gif">
          </div>
          <div class="warning" *ngIf="fileSizeErrorReceipt">{{fileSizeErrorReceipt}}</div>
          <a *ngIf="deduction.AttachmentReciept.Guid != null" class="col-sm-8" mat-stroked-button color="secondary" (click)="showFile(deduction.AttachmentReciept)"><mat-icon>open_in_new</mat-icon>&nbsp; Visa dokument</a>&nbsp;
          <a *ngIf="deduction.AttachmentReciept.Guid != null" class="warning right col-sm-3" mat-stroked-button color="secondary" (click)="deleteFile(deduction.AttachmentReciept)">Radera</a>&nbsp;
        </div>

        <div class="col-sm-12 sp-form-field dialog-action-block">
          <div class="dialog-action-buttons">
            <button type="button" mat-stroked-button (click)="cancel()" color="secondary">Avbryt</button>
            <button mat-raised-button [disabled]="!f.form.valid || deduction.Attachment.Guid == null" color="accent">Spara</button>
          </div>
          <div class="missing-requirement" *ngIf="getMissingRequirementMessage(f) as missingMessage">{{missingMessage}}</div>
        </div>

      </div>
    </div>
  </div>
  </form>
</div>

<!--<div mat-dialog-actions align="end" *ngIf="data.invoiceItemGroup.Type.Name != undefined" style="margin-bottom:15px;">
  
  <div *ngIf="!validates()" style="width: 100%;">
    <span style="color:red;float:left;margin-bottom:5px;">Välj datum och tid för att visa på faktura</span>
  </div>

  <button mat-stroked-button *ngIf="canEditGroup()" align="left" color="secondary" style="width:32%" (click)="deleteRow()">radera</button>&nbsp;
  <button mat-stroked-button [disabled]="!validates()" color="secondary" style="width:32%" (click)="saveRow()">Spara</button>&nbsp;
  <button mat-stroked-button *ngIf="!data.invoiceItemGroup.isNew" style="width:32%" (click)="cancel()">avbryt</button>&nbsp;
  
</div>-->

